import { ActivityIndicator } from 'components/BlockingLoader/ActivityIndicator';
import { Card } from 'components/Card';
import { CardRow } from 'components/CardRow';
import { GapNone } from 'components/GapNone';
import { GapSmall } from 'components/GapSmall';
import { ICONS } from 'components/Icon';
import { Txt } from 'components/Txt';
import { filterArrayEmpty } from 'lib/riskbase';
import { theme } from 'lib/theme';
import React from 'react';
import { EngagePropertyListItem } from 'types/Engage';

export type DeliveryGroup = {
  label: string;
  key: string;
  flats: { id: string; name: string; text: string }[];
};

type Props = {
  property: EngagePropertyListItem;
  deliveryGroups: DeliveryGroup[];
  loading: boolean;
};

export const EngageCommunicationDeliveryGroups: React.FC<Props> = ({
  property,
  deliveryGroups,
  loading = false,
}) => {
  const [isOpen, setIsOpen] = React.useState<Record<string, boolean>>({});

  return (
    <GapNone>
      <Card label="Message Recipients" labelSize="large" />
      <GapSmall>
        {loading ? (
          <Card>
            <CardRow contentStyle={{ paddingTop: 0, paddingBottom: 0 }}>
              <ActivityIndicator size={16} />
            </CardRow>
          </Card>
        ) : deliveryGroups.length ? (
          deliveryGroups.map((deliveryGroup) => {
            const isPreviewOpen = !!isOpen[deliveryGroup.key];
            return (
              <Card key={deliveryGroup.label}>
                <CardRow
                  icon={ICONS.ChevronRightLight}
                  iconSize={16}
                  iconStyle={{
                    transform: [{ rotate: isPreviewOpen ? '90deg' : '0deg' }],
                  }}
                  label={deliveryGroup.label}
                  onPress={() => {
                    setIsOpen((prev) => ({
                      ...prev,
                      [deliveryGroup.key]: !prev[deliveryGroup.key],
                    }));
                  }}
                ></CardRow>
                {isPreviewOpen &&
                  deliveryGroup.flats.map((flat) => (
                    <CardRow key={flat.id}>
                      <Txt>
                        <Txt>{flat.name}</Txt>
                        <Txt size="small">
                          ,{' '}
                          {[...(property.addressLines || []), property.postcode]
                            .filter(filterArrayEmpty)
                            .join(', ')}
                        </Txt>
                      </Txt>
                      {!!flat.text && (
                        <Txt
                          size="small"
                          style={{ color: theme.colors.fieldValueText }}
                        >
                          {flat.text}
                        </Txt>
                      )}
                    </CardRow>
                  ))}
              </Card>
            );
          })
        ) : (
          <Card>
            <CardRow label={'No recipients to display'}></CardRow>
          </Card>
        )}
      </GapSmall>
    </GapNone>
  );
};
